import type { ChatMessage, ChatSuggestion } from 'walden-fast/types/chat';
import type { Factory } from 'walden-fast/types/mocks';

const MOCK_MESSAGE: ChatMessage = {
  id: '1',
  role: 'assistant',
  date: new Date(1734528816000),
  content:
    'Hi Charlotte, It seems you need help regarding a connection issue. Would you like me to show you the details?',
};

export const chatMessageFactory: Factory<ChatMessage> = (overrides) => ({
  ...MOCK_MESSAGE,
  id: `${Math.floor(Math.random() * 1000000000)}`,
  ...overrides,
});

const MOCK_CHAT_SUGGESTION: ChatSuggestion = {
  text: 'Static: Provide me my last 10 transport deliveries.',
  immediate: true,
};

export const chatSuggestionFactory: Factory<ChatSuggestion> = (overrides) => ({
  ...MOCK_CHAT_SUGGESTION,
  ...overrides,
});

export const chatResponseFactory: Factory<ChatMessage> = (overrides) => ({
  ...MOCK_MESSAGE,
  id: `${Math.floor(Math.random() * 1000000000)}`,
  role: 'assistant',
  content:
    'The latest sales orders include multiple entries for two customers: Univ Hamburg-Eppendorf and LIT - Leibniz-Inst. Immuntherapie. All orders are marked as "Open." The orders for Univ Hamburg-Eppendorf are for a quantity of 1, while those for LIT - Leibniz-Inst. Immuntherapie vary between 1 and 2. The sales orders were all placed on January 8, 2025. There are 20 rows in total, reflecting these details.',
  data: [
    {
      ClientCode: '120006',
      documentnumber: '2084048',
      documentstatus: 'Open',
      customername: 'Univ Hamburg-Eppendorf',
      datesalesorder: '2025-01-08',
      DateTimeSalesOrder: '2025-01-08T16:31:00Z',
      quantitysalesorder: 1,
    },
    {
      ClientCode: '120006',
      documentnumber: '2084048',
      documentstatus: 'Open',
      customername: 'Univ Hamburg-Eppendorf',
      datesalesorder: '2025-01-08',
      DateTimeSalesOrder: '2025-01-08T16:31:00Z',
      quantitysalesorder: 1,
    },
    {
      ClientCode: '120006',
      documentnumber: '2084048',
      documentstatus: 'Open',
      customername: 'Univ Hamburg-Eppendorf',
      datesalesorder: '2025-01-08',
      DateTimeSalesOrder: '2025-01-08T16:31:00Z',
      quantitysalesorder: 1,
    },
    {
      ClientCode: '120006',
      documentnumber: '2084048',
      documentstatus: 'Open',
      customername: 'Univ Hamburg-Eppendorf',
      datesalesorder: '2025-01-08',
      DateTimeSalesOrder: '2025-01-08T16:31:00Z',
      quantitysalesorder: 1,
    },
    {
      ClientCode: '120006',
      documentnumber: '2084048',
      documentstatus: 'Open',
      customername: 'Univ Hamburg-Eppendorf',
      datesalesorder: '2025-01-08',
      DateTimeSalesOrder: '2025-01-08T16:31:00Z',
      quantitysalesorder: 1,
    },
    {
      ClientCode: '120006',
      documentnumber: '2084003',
      documentstatus: 'Open',
      customername: 'LIT - Leibniz-Inst. Immuntherapie',
      datesalesorder: '2025-01-08',
      DateTimeSalesOrder: '2025-01-08T15:32:00Z',
      quantitysalesorder: 2,
    },
    {
      ClientCode: '120006',
      documentnumber: '2084003',
      documentstatus: 'Open',
      customername: 'LIT - Leibniz-Inst. Immuntherapie',
      datesalesorder: '2025-01-08',
      DateTimeSalesOrder: '2025-01-08T15:32:00Z',
      quantitysalesorder: 2,
    },
    {
      ClientCode: '120006',
      documentnumber: '2084003',
      documentstatus: 'Open',
      customername: 'LIT - Leibniz-Inst. Immuntherapie',
      datesalesorder: '2025-01-08',
      DateTimeSalesOrder: '2025-01-08T15:32:00Z',
      quantitysalesorder: 2,
    },
    {
      ClientCode: '120006',
      documentnumber: '2084003',
      documentstatus: 'Open',
      customername: 'LIT - Leibniz-Inst. Immuntherapie',
      datesalesorder: '2025-01-08',
      DateTimeSalesOrder: '2025-01-08T15:32:00Z',
      quantitysalesorder: 2,
    },
    {
      ClientCode: '120006',
      documentnumber: '2084003',
      documentstatus: 'Open',
      customername: 'LIT - Leibniz-Inst. Immuntherapie',
      datesalesorder: '2025-01-08',
      DateTimeSalesOrder: '2025-01-08T15:32:00Z',
      quantitysalesorder: 1,
    },
    {
      ClientCode: '120006',
      documentnumber: '2084003',
      documentstatus: 'Open',
      customername: 'LIT - Leibniz-Inst. Immuntherapie',
      datesalesorder: '2025-01-08',
      DateTimeSalesOrder: '2025-01-08T15:32:00Z',
      quantitysalesorder: 2,
    },
    {
      ClientCode: '120006',
      documentnumber: '2084003',
      documentstatus: 'Open',
      customername: 'LIT - Leibniz-Inst. Immuntherapie',
      datesalesorder: '2025-01-08',
      DateTimeSalesOrder: '2025-01-08T15:32:00Z',
      quantitysalesorder: 2,
    },
    {
      ClientCode: '120006',
      documentnumber: '2084002',
      documentstatus: 'Open',
      customername: 'LIT - Leibniz-Inst. Immuntherapie',
      datesalesorder: '2025-01-08',
      DateTimeSalesOrder: '2025-01-08T15:31:00Z',
      quantitysalesorder: 1,
    },
    {
      ClientCode: '120006',
      documentnumber: '2084002',
      documentstatus: 'Open',
      customername: 'LIT - Leibniz-Inst. Immuntherapie',
      datesalesorder: '2025-01-08',
      DateTimeSalesOrder: '2025-01-08T15:31:00Z',
      quantitysalesorder: 1,
    },
    {
      ClientCode: '120006',
      documentnumber: '2084002',
      documentstatus: 'Open',
      customername: 'LIT - Leibniz-Inst. Immuntherapie',
      datesalesorder: '2025-01-08',
      DateTimeSalesOrder: '2025-01-08T15:31:00Z',
      quantitysalesorder: 1,
    },
    {
      ClientCode: '120006',
      documentnumber: '2084002',
      documentstatus: 'Open',
      customername: 'LIT - Leibniz-Inst. Immuntherapie',
      datesalesorder: '2025-01-08',
      DateTimeSalesOrder: '2025-01-08T15:31:00Z',
      quantitysalesorder: 1,
    },
    {
      ClientCode: '120006',
      documentnumber: '2084002',
      documentstatus: 'Open',
      customername: 'LIT - Leibniz-Inst. Immuntherapie',
      datesalesorder: '2025-01-08',
      DateTimeSalesOrder: '2025-01-08T15:31:00Z',
      quantitysalesorder: 1,
    },
    {
      ClientCode: '120006',
      documentnumber: '2084002',
      documentstatus: 'Open',
      customername: 'LIT - Leibniz-Inst. Immuntherapie',
      datesalesorder: '2025-01-08',
      DateTimeSalesOrder: '2025-01-08T15:31:00Z',
      quantitysalesorder: 1,
    },
    {
      ClientCode: '120006',
      documentnumber: '2084002',
      documentstatus: 'Open',
      customername: 'LIT - Leibniz-Inst. Immuntherapie',
      datesalesorder: '2025-01-08',
      DateTimeSalesOrder: '2025-01-08T15:31:00Z',
      quantitysalesorder: 1,
    },
    {
      ClientCode: '120006',
      documentnumber: '2084002',
      documentstatus: 'Open',
      customername: 'LIT - Leibniz-Inst. Immuntherapie',
      datesalesorder: '2025-01-08',
      DateTimeSalesOrder: '2025-01-08T15:31:00Z',
      quantitysalesorder: 1,
    },
  ],
  trace_id: '62438a1b-005d-4a12-ab60-cf6f66b262c5',
  ...overrides,
});
